import { Navigation, Pagination, EffectCoverflow, Thumbs } from 'swiper/modules';

export const sliders = {
    sets: {
        modules: [Navigation, Pagination],

        grabCursor: true,
        slidesPerView: 'auto',
        spaceBetween: 4,
        slideClass: 'swiper-slide--set-card',
        pagination: {
            el: '.slider__pagination--sets',
            clickable: true
        },
        navigation: {
            nextEl: '.btn--products-next',
            prevEl: '.btn--products-prev',
        },
    },

    reviews: {
        modules: [Navigation, Pagination],

        slidesPerView: 'auto',
        spaceBetween: 4,
        slideClass: 'swiper-slide--review',
        breakpoints: {
            535: {
                slidesPerView: 2
            },
            771: {
                slidesPerView: 3
            },
            1021: {
                slidesPerView: 4
            }
        },
        pagination: {
            el: '.slider__pagination--reviews',
            clickable: true
        },
        navigation: {
            nextEl: '.btn--reviews-next',
            prevEl: '.btn--reviews-prev',
        },
    },

    photos: {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 4,
        slideClass: 'swiper-slide--photo',

        pagination: {
            el: '.slider__pagination--photos',
            clickable: true
        },

        navigation: {
            nextEl: '.btn--photos-next',
            prevEl: '.btn--photos-prev',
        },
		on: {
			init: function () {
				toggleButtons(this);
			},
			update: function () {
				toggleButtons(this);
			},
		}
    },

	insta: {
		modules: [Navigation, Pagination],
		slidesPerView: 1,
		spaceBetween: 4,
		slideClass: 'swiper-slide--insta',

		pagination: {
			el: '.slider__pagination--insta',
			clickable: true
		},

		navigation: {
			nextEl: '.btn--insta-next',
			prevEl: '.btn--insta-prev',
		}
	},

    cars: {
        modules: [EffectCoverflow],
        effect: 'coverflow',
        centeredSlides: true,
        slideClass: 'swiper-slide--car',
        slidesPerView: 'auto',
        coverflowEffect: {
            scale: 1,
            rotate: 0,
            stretch: -50,
            depth: 1600,
            modifier: 1,
            slideShadows: false,
        },

        breakpoints: {
            368: {
                coverflowEffect: {
                    stretch: -440,
                    depth: 1600,
                }
            },
            921: {
                allowTouchMove: false,
                coverflowEffect: {
                    stretch: -440,
                    depth: 1600,
                }
            },
        }
    },

    products: {
        modules: [Navigation, Pagination],

        slidesPerView: 1,
        spaceBetween: 4,
        slideClass: 'swiper-slide--product',
        breakpoints: {
            535: {
                slidesPerView: 2
            },
            771: {
                slidesPerView: 3
            },
            1021: {
                slidesPerView: 4
            }
        },
        watchOverflow: true,
        pagination: {
            el: '.slider__pagination--products',
            clickable: true
        },
        navigation: {
            nextEl: '.btn--products-next',
            prevEl: '.btn--products-prev',
        },
        on: {
            init: function () {
                toggleButtons(this);
            },
            update: function () {
                toggleButtons(this);
            },
        }
    },

    thumbnails: {
        direction: "vertical",
        slidesPerView: 'auto',
        spaceBetween: 4,
        slideClass: 'swiper-slide--thumb',
    },

    images: {
        modules: [Thumbs, Pagination],
        slidesPerView: 1,
        spaceBetween: 4,
        slideClass: 'swiper-slide--img',
        pagination: {
            el: '.slider__pagination--images',
        },
    }
};

function toggleButtons(s) {
    const display = s.isLocked ? 'none' : 'flex';
    s.navigation.nextEl.style.display = display;
    s.navigation.prevEl.style.display = display;
}
